import { api } from 'api'

type GetWorkBreaksResponseBreak = {
  breakNumber: number
  durationInMinutes: number
  startTime?: string
  endTime?: string
  status?: 'taking' | 'taken' | 'waived' | 'missed'
  presentationStatus:
    | 'scheduled'
    | 'available'
    | 'overdue'
    | 'taking'
    | 'resolved'
  reason?: string
  takeAfter?: string
  takeBefore?: string
  breakType: 'meal' | 'rest'
  requirementType: 'required' | 'optional'
  waivePolicy?: 'allowed' | 'allowed_if_previous_taken'
  payTreatment: 'paid' | 'unpaid'
  issue?: 'required_not_recorded' | 'in_progress' | 'required_not_taken'
}

type GetWorkBreaksResponse = {
  breaks: GetWorkBreaksResponseBreak[]
  isSelfClockedOut: boolean
}

export async function getWorkBreaks(companyId: number, workId: number) {
  const response = await api.get<GetWorkBreaksResponse>(
    `/company/${companyId}/work/${workId}/break`
  )
  return response.data
}
